export default {
  heading: 'From the journal',
  articleCount: 'no articles | one article | {count} articles',
  loading: 'Loading…',
  loadError: 'Could not load articles.',
  empty: 'No articles published yet.',
  featured: 'Featured',
  read: 'Read',
  pagination: {
    prev: '← Prev',
    next: 'Next →',
    pageOf: 'Page {page} of {total}',
  },
  notFound: {
    title: 'Article not found',
    description: "It may have been removed or isn't published yet.",
    allArticles: '← All articles',
  },
};
